// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { length } from '../../../../../../../common/utils/immutableHelper';

// Selectors
import { currentBoardEditorAvatarsSelector } from './boardEditorPanelSelector';
import { currentBoardIdSelector } from '../../../../../../element/board/boardSelector';

// Components
import BoardEditorList from './editorList/BoardEditorList';

// Actions
import { fetchBoardEditorTimes } from './boardEditorPanelActions';

// Hooks
import useBooleanRatchet from '../../../../../../utils/react/useBooleanRatchet';

// Styles
import './BoardEditorsSection.scss';

const mapStateToProps = createStructuredSelector({
    currentBoardId: currentBoardIdSelector,
    currentBoardEditors: currentBoardEditorAvatarsSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchEditorTimes: (elementId) => dispatch(fetchBoardEditorTimes(elementId, true)),
});

const BoardEditorsSection = (props) => {
    const { currentBoardEditors, currentBoardId, dispatchFetchEditorTimes } = props;

    const editorsCount = length(currentBoardEditors);
    const showForm = useBooleanRatchet(editorsCount > 1);

    // Fetch the user viewed times on mount
    React.useEffect(() => {
        dispatchFetchEditorTimes(currentBoardId);
    }, []);

    if (!showForm) return null;

    return (
        <div className="BoardEditorsSection">
            <h2>
                Current editors
                {editorsCount > 1 && ` (${editorsCount})`}
            </h2>
            <BoardEditorList {...props} />
        </div>
    );
};

BoardEditorsSection.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    currentBoardEditors: PropTypes.array,
    currentBoardId: PropTypes.string,
    dispatchFetchEditorTimes: PropTypes.func,
    isPhoneOrMobileAppMode: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(BoardEditorsSection);
